module.exports = __webpack_public_path__ + "static/media/carolus-tripel.a2d82cc6.jpg";